import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import landingBg1 from '../assets/images/20232024conferencephotos/14.png';
import landingBg2 from '../assets/images/2024publicspeakingphotos/4.png';
import landingBg3 from '../assets/images/20232024conferencephotos/1.png';
import landingBg4 from '../assets/images/2024publicspeakingphotos/7.png';
import landingBg5 from '../assets/images/2024publicspeakingphotos/8.png';
import conferenceImage from '../assets/images/20232024conferencephotos/13.png';
import speakingImage from '../assets/images/2024publicspeakingphotos/9.png';
import teamImage from '../assets/images/2024publicspeakingphotos/10.png';

const Landing = () => {
  const navigate = useNavigate();
  const heroRef = useRef(null);
  const [currentBg, setCurrentBg] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  const backgroundImages = [
    landingBg1,
    landingBg2,
    landingBg3,
    landingBg4,
    landingBg5
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    
    // Auto-scroll to hero section on load
    heroRef.current.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
    
    // Background slideshow
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % backgroundImages.length);
    }, 3000);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, [backgroundImages.length]);

  const handleConferenceClick = () => {
    navigate('/conference');
  };

  const handleSpeakingClick = () => {
    navigate('/publicspeakingcontest');
  };

  const handleTeamClick = () => {
    navigate('/team');
  };

  return (
    <div className="landing-container" ref={heroRef}>
      {/* HERO SECTION */}
      <section className="hero-section">
        {backgroundImages.map((image, index) => (
          <div 
            key={index}
            className={`hero-bg-image ${index === currentBg ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-tagline">
            {isMobile ? (
              <>
                EST. 2019. STUDENTS ADVOCATING FOR CLEAN AIR IN HONG KONG.
              </>
            ) : (
              <>
                EST. 2019.<br />
                STUDENTS<br />
                ADVOCATING<br />
                FOR CLEAN AIR<br />
                IN HONG KONG.
              </>
            )}
          </h1>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" className="about-section">
        <div className="about-container">
          <h2 className="section-title">ABOUT</h2>
          
          <div className="numbers-grid">
            {[
              { value: "1000+", label: "students directly empowered" },
              { value: "30+", label: "schools" },
              { value: "8+", label: "years of clean air commitment" }
            ].map((item, index) => (
              <div className="number-item" key={index}>
                <span className="number">{item.value}</span>
                <span className="number-label">{item.label}</span>
              </div>
            ))}
          </div>

          <div className="about-description">
            <p>
              Established in 2019, CASC is Hong Kong's largest and oldest student-led environmental group. Being the youth branch of Clean Air Network, our mission is to advocate for better air quality in Hong Kong by empowering students in clean air action.
            </p>
          </div>
        </div>
      </section>

      {/* OUR WORK SECTION */}
      <section id="work" className="work-section">
        <div className="work-container">
          <h2 className="section-title">OUR WORK</h2>
          
          <div className="work-cards">
            <div className="work-card" onClick={handleConferenceClick}>
              <img src={conferenceImage} alt="Clean Air Conference" />
              <div className="card-content">
                <h3 className="card-title">Clean Air Conference</h3>
                <p className="card-subtitle">Flagship Event</p>
                <p className="card-text">Asia's largest student-led clean air conference.</p>
              </div>
            </div>
            
            <div className="work-card" onClick={handleSpeakingClick}>
              <img src={speakingImage} alt="Public Speaking Contest" />
              <div className="card-content">
                <h3 className="card-title">Hong Kong Clean Air Public Speaking Contest</h3>
                <p className="card-subtitle">Flagship Event</p>
                <p className="card-text">A platform for hundreds of young voices to advocate for cleaner air and a healthier planet.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OUR TEAM SECTION */}
      <section id="team" className="team-section">
        <div className="team-container">
          <h2 className="section-title">OUR TEAM</h2>
          
          <div className="team-card" onClick={handleTeamClick}>
            <img src={teamImage} alt="Executive Board" className="team-photo" />
            <div className="team-card-content">
              <h3 className="team-card-title">Meet the 2026-2027 Executive Board</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;